import { LegacyCard } from '@shopify/polaris';
import { useContext } from 'react';
import { useState } from 'react';
import ToastContext from '../../../context/ToastContext';
import { SET_ERROR, SET_OK } from '../../../context/ToastReducer';
import { getProducts } from '../../../services/productService';
import { getTransferStockById, postTransferStockById } from '../../../services/transfersService';
import ProductCard from '../Products/ProductCard';
import ProductFindCard from '../Products/ProductFindCard';
import TransferAddStockTable from '../Tables/TransferAddStockTable';

const AddStockCard = ({ transfer, onStockAdded }) => {
  const [productFound, setProductFound] = useState(null);
  const [productListFound, setProductListFound] = useState([]);
  const [stockToAdd, setStockToAdd] = useState([]);
  const [, dispatchToast] = useContext(ToastContext);

  const handleSearch = (family) =>
    getProducts({ s: family, empty: true }).then((r) => {
      if (r.data.data.length === 1) {
        setProductFound(r.data.data[0]);
        setProductListFound([]);
      } else {
        setProductFound(null);
        setProductListFound(r.data.data.map(({ family }) => family));
      }
    });

  const handleClearSearch = () => {
    setProductFound(null);
    setProductListFound([]);
  };

  const handleStockToAddChange = (qtys) => {
    setStockToAdd(qtys);
  };

  const handleAddQty = () =>
    postTransferStockById(transfer.id, stockToAdd)
      .then((r) => {
        getTransferStockById(transfer.id, { s: productFound.family }).then((rr) => onStockAdded(rr.data.data[0]));
        setProductFound(null);
        setProductListFound([]);
        setStockToAdd([]);
        dispatchToast({ type: SET_OK, payload: r.data });
      })
      .catch((e) => {
        dispatchToast({ type: SET_ERROR, payload: e.response.data });
      });

  return (
    <LegacyCard
      title="Añadir stock"
      primaryFooterAction={
        productFound && { content: 'Añadir stock', disabled: !stockToAdd.length, onAction: handleAddQty }
      }
      secondaryFooterActions={
        productFound && [{ content: 'Limpiar', onAction: handleClearSearch, destructive: true, plain: true }]
      }>
      <LegacyCard.Section>
        <ProductFindCard
          onSearch={handleSearch}
          onClearSearch={handleClearSearch}
          product={productFound}
          optionList={productListFound}
        >
          {productFound && (
            <ProductCard product={productFound} wide={true}>
              <TransferAddStockTable product={productFound} transfer={transfer} onAddQty={handleStockToAddChange} />
            </ProductCard>
          )}
        </ProductFindCard>
      </LegacyCard.Section>
    </LegacyCard>
  );
};

export default AddStockCard;
